<div>
    <div class="page_title">
        <div class="row marges">
            <div class="col y_items_center">
                <h1 class="title">{{ 'quotation.plural.value' | translate }}</h1>
            </div>
            @if(hasAccess('QUOTATION_LIST_IS_MINE')) {
                <div class="col_content y_items_center">
                    <button (click)="exportQuotation()" class="btn_cta btn_little">{{ 'quotation.list.export.value' | translate }}</button>
                </div>
            }
            @if(isAdmin()) {
                <div class="col_content y_items_center">
                    <button (click)="adminExportQuotation()" class="btn_cta btn_little">{{ 'quotation.list.adminExport.value' | translate }}</button>
                </div>
            }
        </div>

    </div>

    <div class="content_table">

        <table mat-table matSort [dataSource]="items" class="mat-elevation-z8">

            <!-- Filtres -->

            <ng-container>

                <ng-container [matColumnDef]="getFilterColumnDef('actions')">
                    <th mat-header-cell *matHeaderCellDef>
                        <button (click)="resetFilters()" mat-icon-button>
                            <mat-icon>loop</mat-icon>
                        </button>
                    </th>
                </ng-container>

                <!-- Numéro de dossier ty-Win -->

                <ng-container [matColumnDef]="getFilterColumnDef('reference')">
                    <th mat-header-cell *matHeaderCellDef>
                        <app-core-text-filter #filter [builder]="filterBuilder" [label]="'folder.numero.tywin.value' | translate" [key]="'reference'" [operator]="'lk'"></app-core-text-filter>
                    </th>
                </ng-container>

                <!-- Nom de l'émetteur -->

                <ng-container [matColumnDef]="getFilterColumnDef('society')">
                    <th mat-header-cell *matHeaderCellDef>
                        <app-core-text-filter #filter [builder]="filterBuilder" [label]="'transmitter.name.value' | translate" [key]="'society.name'" [operator]="'lk'"></app-core-text-filter>
                    </th>
                </ng-container>

                <!-- ID du collaborateur émetteur -->

                <ng-container [matColumnDef]="getFilterColumnDef('responsibleUserId')">
                    <th mat-header-cell *matHeaderCellDef>
                        <app-core-text-filter #filter [builder]="filterBuilder" [label]="'collaborator.transmitter.id.value' | translate" [key]="'responsibleUser.id'" [operator]="'eq'"></app-core-text-filter>
                    </th>
                </ng-container>

                <!-- Nom du collaborateur émetteur -->

                <ng-container [matColumnDef]="getFilterColumnDef('responsibleUserLastName')">
                    <th mat-header-cell *matHeaderCellDef>
                        <app-core-text-filter #filter [builder]="filterBuilder" [label]="'collaborator.transmitter.lastName.value' | translate" [key]="'responsibleUser.lastName'" [operator]="'lk'"></app-core-text-filter>
                    </th>
                </ng-container>

                <!-- Prénom du collaborateur émetteur -->

                <ng-container [matColumnDef]="getFilterColumnDef('responsibleUserFirstName')">
                    <th mat-header-cell *matHeaderCellDef>
                        <app-core-text-filter #filter [builder]="filterBuilder" [label]="'collaborator.transmitter.firstName.value' | translate" [key]="'responsibleUser.firstName'" [operator]="'lk'"></app-core-text-filter>
                    </th>
                </ng-container>

                <!-- Date de la demande -->

                <ng-container [matColumnDef]="getFilterColumnDef('createdAt')">
                    <th mat-header-cell *matHeaderCellDef>
                        <app-core-date-interval-filter #filter [builder]="filterBuilder" [key]="'createdAt'" [startOperator]="'gte'" [endOperator]="'lte'"></app-core-date-interval-filter>
                    </th>
                </ng-container>

                <!-- Référence -->

                <ng-container [matColumnDef]="getFilterColumnDef('ownerReference')">
                    <th mat-header-cell *matHeaderCellDef>
                        <app-core-text-filter #filter [builder]="filterBuilder" [label]="'reference.value' | translate" [key]="'ownerReference'" [operator]="'lk'"></app-core-text-filter>
                    </th>
                </ng-container>

                <!-- Statut -->

                <ng-container [matColumnDef]="getFilterColumnDef('status')">
                    <th mat-header-cell *matHeaderCellDef>
                        <app-core-select-filter #filter [builder]="filterBuilder" [label]="'quotation.status.value' | translate" [key]="'status'" [operator]="'eq'" [itemValueProperty]="'id'" [itemLabelProperty]="'label'" [items]="status"></app-core-select-filter>
                    </th>
                </ng-container>

                <!-- Date limite de réponse -->

                <ng-container [matColumnDef]="getFilterColumnDef('closedAt')">
                    <th mat-header-cell *matHeaderCellDef>
                        <app-core-date-interval-filter #filter [builder]="filterBuilder" [key]="'closedAt'" [startOperator]="'gte'" [endOperator]="'lte'"></app-core-date-interval-filter>
                    </th>
                </ng-container>

                <!-- Cible de clientèe -->

                <ng-container [matColumnDef]="getFilterColumnDef('customerTypology')">
                    <th mat-header-cell *matHeaderCellDef>
                        <app-core-select-filter #filter [builder]="filterBuilder" [label]="'customer.target.value' | translate" [key]="'configuration.customerTypology.id'" [operator]="'eq'" [itemValueProperty]="'id'" [itemLabelProperty]="'label'" [items]="customerTypologies"></app-core-select-filter>
                    </th>
                </ng-container>

                <!-- Destinations -->

                <ng-container [matColumnDef]="getFilterColumnDef('regions')">
                    <th mat-header-cell *matHeaderCellDef></th>
                </ng-container>

                <!-- Budget par personne -->

                <ng-container [matColumnDef]="getFilterColumnDef('pricing.budget')">
                    <th mat-header-cell *matHeaderCellDef>
                        <app-core-text-filter #filter [builder]="filterBuilder" [label]="'budget.perPerson.value' | translate" [key]="'pricing.budget'" [operator]="'lk'"></app-core-text-filter>
                    </th>
                </ng-container>

            </ng-container>

            <!-- Liste des données -->

            <ng-container>

                <!--Actions-->

                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef>{{'actions.label.value' | translate}}</th>
                    <mat-cell *matCellDef="let element; let i = index">

                        @if(['read', 'write'].includes(getModel(element).hasAccess)) {
                            <button mat-button (click)="view(element.id)">
                                <mat-icon>{{ getModel(element).hasAccess === 'write' && isQuotationUpdateAllowed ? 'edit' : 'visibility' }}</mat-icon>
                            </button>
                        }

                        @if(userService.hasOneOfThisRoles(currentUser, ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'])) {
                            <button mat-button (click)="openDeleteItemDialog(element.id)">
                                <mat-icon>delete</mat-icon>
                            </button>
                        }
                    </mat-cell>
                </ng-container>

                <!-- Numéro de dossier Ty-Win -->

                <ng-container matColumnDef="reference">
                    <th mat-header-cell *matHeaderCellDef>{{ 'folder.numero.tywin.value' | translate }}</th>
                    <td mat-cell *matCellDef="let element">{{ getModel(element).reference }}</td>
                </ng-container>

                <!-- Nom de l'émetteur -->

                <ng-container matColumnDef="society">
                    <th mat-header-cell *matHeaderCellDef>{{ 'transmitter.name.value' | translate }}</th>
                    <td mat-cell *matCellDef="let element">{{ getModel(element).society.name }}</td>
                </ng-container>

                <!-- ID du collaborateur émetteur  -->

                <ng-container matColumnDef="responsibleUserId">
                    <th mat-header-cell *matHeaderCellDef>{{ 'collaborator.transmitter.id.value' | translate }}</th>
                    <td mat-cell *matCellDef="let element">{{ getModel(element).responsibleUser.id }}</td>
                </ng-container>

                <!-- Nom du collaborateur émetteur  -->

                <ng-container matColumnDef="responsibleUserLastName">
                    <th mat-header-cell *matHeaderCellDef>{{ 'collaborator.transmitter.lastName.value' | translate }}</th>
                    <td mat-cell *matCellDef="let element">{{ getModel(element).responsibleUser.lastName }}</td>
                </ng-container>

                <!-- Prénom du collaborateur émetteur  -->

                <ng-container matColumnDef="responsibleUserFirstName">
                    <th mat-header-cell *matHeaderCellDef>{{ 'collaborator.transmitter.firstName.value' | translate }}</th>
                    <td mat-cell *matCellDef="let element">{{ getModel(element).responsibleUser.firstName }}</td>
                </ng-container>

                <!-- Date de la demande -->

                <ng-container matColumnDef="createdAt">
                    <th mat-header-cell *matHeaderCellDef>{{ 'request.date.value' | translate }}</th>
                    <td mat-cell *matCellDef="let element">{{ getModel(element).createdAt | date : 'shortDate' : null : localeId }}</td>
                </ng-container>

                <!-- Référence -->

                <ng-container matColumnDef="ownerReference">
                    <th mat-header-cell *matHeaderCellDef>{{ 'reference.value' | translate }}</th>
                    <td mat-cell *matCellDef="let element">{{ getModel(element).ownerReference }}</td>
                </ng-container>

                <!-- Statut -->

                <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef>{{'quotation.status.value' | translate}}</th>
                    <td mat-cell *matCellDef="let element">{{ ('status.' + getModel(element).status + '.value' | translate) }}</td>
                </ng-container>

                <!-- Date limite de réponse -->

                <ng-container matColumnDef="closedAt">
                    <th mat-header-cell *matHeaderCellDef>{{'response.date.limit.value' | translate}}</th>
                    <td mat-cell *matCellDef="let element">{{ getModel(element).closedAt | date : 'shortDate' : null : localeId }}</td>
                </ng-container>

                <!-- Cible de clientèle -->

                <ng-container matColumnDef="customerTypology">
                    <th mat-header-cell *matHeaderCellDef>{{'customer.target.value' | translate}}</th>
                    <td mat-cell *matCellDef="let element">{{ translationService.getFallbackTranslation(getModel(element).configuration.customerTypology.translations).name }}</td>
                </ng-container>

                <!-- Destinations -->

                <ng-container matColumnDef="regions">
                    <th mat-header-cell *matHeaderCellDef>{{'destination.plural.value' | translate}}</th>
                    <td mat-cell *matCellDef="let element">{{ parsedItemRegions(getModel(element)) }}</td>
                </ng-container>

                <!-- Budget par personne -->

                <ng-container matColumnDef="pricing.budget">
                    <th mat-header-cell *matHeaderCellDef>{{ 'budget.perPerson.value' | translate }}</th>
                    <td mat-cell *matCellDef="let element">{{ getModel(element).pricing.budget }} {{ getModel(element).pricing.currency.symbol }}</td>
                </ng-container>

            </ng-container>

            <!-- Entêtes de colonne -->

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

            <!-- Filtres -->

            <tr mat-header-row *matHeaderRowDef="displayedFilterColumns"></tr>

            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>

    <!--Pagination-->

    <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions" [length]="totalItems"></mat-paginator>

</div>
